import Button from "../shared/button/button";
import { stylizationWrapperRight } from "../shared/stylization";
import Wrapper from "../shared/wrapper/wrapper";
import { ButtonFieldProps } from "./types/buttonFieldProps";


const ButtonField = (props: ButtonFieldProps) => {
    var stylization = (props.wrapperProps === undefined || props.wrapperProps?.style === undefined) ? stylizationWrapperRight : props.wrapperProps?.style
    return (
        <Wrapper {...props.wrapperProps} style={stylization} children={<Button {...props}></Button>}/>
    )
}

export default ButtonField;